module.exports = __webpack_public_path__ + "static/media/icon-plus.2c0248d8.svg";